module.exports = __webpack_public_path__ + "static/img/041004.fea6dd4a.png";